import {
  TaskDetailsDto,
  TaskStatus,
  CHECKLIST_TASK_STATUS_VALUES,
  TaskType,
  INSPECTION_TASK_STATUS_VALUES,
} from '@/core';
import { Form } from '@/components';
import { useUpdateTaskStatusMutation } from '@/redux';
import { useCallback } from 'react';
import * as Yup from 'yup';

function useHandleClick(taskId: string) {
  const [change] = useUpdateTaskStatusMutation();

  return useCallback(
    (value: { status: TaskStatus }) =>
      change({ taskId, status: value.status }).unwrap(),
    [change, taskId],
  );
}

const schema = Yup.object().shape({
  status: Yup.mixed<TaskStatus>().nullable().required(),
});

interface Props {
  task: Pick<TaskDetailsDto, 'id' | 'type' | 'status'>;
  readonly?: boolean;
  className?: string;
}

export function TaskStatusForm(props: Props) {
  const { task, readonly, className } = props;
  const handleClick = useHandleClick(task.id);

  return (
    <div className={className}>
      <Form.Formik<{ status: TaskStatus }>
        uid="task-status"
        onSubmit={handleClick}
        initialValues={task}
        enableReinitialize
        validationSchema={schema}
      >
        {(formik) => (
          <>
            <Form.EnumSelect
              type={TaskStatus}
              values={
                task.type === TaskType.Checklist
                  ? CHECKLIST_TASK_STATUS_VALUES
                  : INSPECTION_TASK_STATUS_VALUES
              }
              name="status"
              onBlur={() => {
                const currentValue = formik.values.status as TaskStatus;

                if (currentValue !== task.status) {
                  formik.submitForm();
                }
              }}
              label={false}
              disabled={readonly}
              allowClear={false}
            />
          </>
        )}
      </Form.Formik>
    </div>
  );
}
